import { useForm } from 'react-hook-form';

import { Form, TextField } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';
import { useAppContext } from '@app-velocity/config';

export type ScenarioShareLinkProps = {
  shareToken: string;
};

export const ShareScenarioLink = ({ shareToken }: ScenarioShareLinkProps) => {
  const { AVMLink } = useAppContext();
  const { t } = useI18n();
  const { control } = useForm();

  return (
    <Form.FieldContainer>
      <Form.Label>{t('prototypes:sharing_link')}</Form.Label>
      <TextField
        name="shareLink"
        control={control}
        fullWidth
        disabled
        defaultValue={`${AVMLink}/scenario/${shareToken}`}
      />
    </Form.FieldContainer>
  );
};
